import { create } from "zustand";
import { type User } from "@/lib/types";

interface UserData {
  user: any;
  setUser: (user: User) => void;
}

const useUserData = create<UserData>((set) => ({
  user: null,
  setUser: (user: any) => set(() => ({ user })),

  //   replaceComment: (updatedComment: Comment) =>
  //     set((state) => ({
  //       comments: state.comments.map((comment) =>
  //         comment._id === updatedComment._id ? updatedComment : comment
  //       ),
  //     })),
  //   removeComment: (commentId: string) =>
  //     set((state) => ({
  //       comments: state.comments.filter(
  //         (comment: Comment) => commentId !== comment._id
  //       ),
  //     })),
  //   updateCommentsReplies: (commentId: string, reply: any) =>
  //     set((state) => ({
  //       comments: state.comments.map((comment) =>
  //         comment._id === commentId
  //           ? {
  //               ...comment,
  //               replies: [...(comment.replies || []), reply],
  //             }
  //           : comment
  //       ),
  //     })),
}));

export default useUserData;
